// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__7p0BY","spin":"Spinner_spin__FsatA"};